module.exports = __webpack_public_path__ + "img/aboutus.717eb36f.jpg";